import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo/google_logo.png'


const _withScopeId = n => (_pushScopeId("data-v-46336d72"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn-container" }
const _hoisted_2 = {
  key: 1,
  class: "spinner-container"
}
const _hoisted_3 = {
  key: 1,
  id: "web-mobile-google-sign-in-button"
}

import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { googleSignIn, initWebGoogleSignIn } from '@/mobile/src/utils/capacitor'
import { loginWithGoogleIdToken } from '@/mobile/src/api/auth'
import SimpleSpinner from '@/components/SimpleSpinner.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GoogleAuthButton',
  emits: ['signin'],
  setup(__props, { emit: __emit }) {

const emit = __emit
const store = useStore()

const loading = ref(false)

const isNativePlatform = computed(
    () => store.getters['deviceInfo']?.platform !== 'web' ?? true
)

onMounted(() => {
    if (!isNativePlatform.value) {
        initWebGoogleSignIn((googleUserAuthId: string) =>
            doWebGoogleSignIn(googleUserAuthId)
        )
    }
})

const doWebGoogleSignIn = async (googleUserAuthId: string) => {
    const data = await loginWithGoogleIdToken(googleUserAuthId)
    if (data) {
        await emit('signin', data)
    }
}

const doNativeGoogleSignIn = async () => {
    if (loading.value) {
        return
    }
    loading.value = true
    let data
    const result = await googleSignIn()

    if (result?.success && result?.googleUserAuthId) {
        data = await loginWithGoogleIdToken(result.googleUserAuthId)
    } else {
        data = result
    }
    emit('signin', data)
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isNativePlatform.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn-google-auth",
          onClick: doNativeGoogleSignIn
        }, [
          _createElementVNode("img", {
            class: _normalizeClass(["icon", { 'not-loading': !loading.value }]),
            src: _imports_0,
            alt: "Google"
          }, null, 2),
          (!loading.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(" Login with Google ")
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(SimpleSpinner, {
                  size: "small",
                  class: "spinner",
                  "line-fg-color": "transparent"
                })
              ]))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3))
  ]))
}
}

})